import Vue from "vue";

/**
 * 侧栏固定与否记在本机；默认不固定，平时收成图标列给列表操作列留出横向空间，
 * 鼠标移上去整栏浮出（见 Layout.vue）。读写失败（隐私模式等）按不固定处理。
 */
const SIDEBAR_PINNED_KEY = "cms.sidebar.pinned";

function readSidebarPinned() {
  try {
    return window.localStorage.getItem(SIDEBAR_PINNED_KEY) === "1";
  } catch (e) {
    return false;
  }
}

// 部分组件值存储的地方（observable）；isCollapse 为 false 即侧栏固定展开
export const store = Vue.observable({ isCollapse: !readSidebarPinned(), breadTitle: "" });
// 修改组件存储值的地方
export const mutations = {
  setIsCollapse(flag) {
    store.isCollapse = flag;
    try {
      window.localStorage.setItem(SIDEBAR_PINNED_KEY, flag ? "0" : "1");
    } catch (e) {
      // 记不住只影响刷新后的默认状态
    }
  },
  setBreadTitle(params) {
    store.breadTitle = params;
  },
};
